import { render, staticRenderFns } from "./externalFiltersList.vue?vue&type=template&id=20b3b41d"
import script from "./externalFiltersList.vue?vue&type=script&lang=js"
export * from "./externalFiltersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports